import './index.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import Entrypoint from './core/Entrypoint'
import { startRouter, store } from './routes'
import { RootRouterStoreContext } from './hooks/router'
import { config } from './config/config'
import './i18n'
import { initServiceWorker } from './worker'
import { Toaster } from './components/ui/sonner'

initServiceWorker()
startRouter()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <RootRouterStoreContext.Provider value={store}>
      <Entrypoint />
      <Toaster position="bottom-center" />
    </RootRouterStoreContext.Provider>
  </React.StrictMode>
)
